import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ETipoPreferencia, ETipoProducto } from 'src/app/models/enums.enum';
import {  IItem, IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { ObservacionesComponent } from '../../../form-componentes/observaciones/observaciones.component';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { SelectSearchMaterialComponent } from '../../../form-componentes/material-framework/select-search-material/select-search-material.component';
import { preferencias } from 'src/app/models/General/preferencias';
import { GrupoPreferenciaComponent } from '../../../form-componentes/grupo-preferencia/grupo-preferencia.component';
import { UserService } from 'src/app/servicios/user.service';

@Component({
  selector: 'app-preferencia-aereo',
  templateUrl: './preferencia-aereo.component.html',
  styleUrls: ['./preferencia-aereo.component.scss']
})
export class PreferenciaAereoComponent extends preferencias implements OnInit {

  @ViewChild('Grupo_Preferencia_Aereo_Companias') Grupo_Preferencia_Aereo_Companias: SelectSearchMaterialComponent;
  @ViewChild('Grupo_Preferencia_Aereo_Observaciones') Grupo_Preferencia_Aereo_Observaciones: ObservacionesComponent;
  @ViewChildren('Grupo_Preferencia_Aereo') grupos!: QueryList<GrupoPreferenciaComponent>;

  constructor(private _userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }
  
  ETipoProducto = ETipoProducto;
  numero: number = 0;

  @Input() preferencias: IPreferencia[];
  @Input() AereoLineas: IItem[];

  @Input() clienteFicha: IFichaCliente;
  @Input() listaOtros: string[];
  
  //Obtener la lista de las preferencias aereas guardadas
  obtenerPreferenciasGuardadas(): IPreferenciaCliente[] {

    let ListaPreferencias: IPreferenciaCliente[] = []

    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();

      let InfoEspecifica = resultado[1];
      if (grupo.Id === 6) {
        InfoEspecifica = this.obtenerNumero();
      }
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: InfoEspecifica
      };
      ListaPreferencias.push(opcionesPreferencias);
    });

    let AereoCompanias = this.Grupo_Preferencia_Aereo_Companias.obtenerPreferencias();


    let CompaniasAereo: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('CompaniasAreas'),
      Preferencias: AereoCompanias,
      InfoEspecifica: null
    }
    ListaPreferencias.push(CompaniasAereo)


    let textoObservacion = this.Grupo_Preferencia_Aereo_Observaciones.obtenerPreferencias();
    let preferenciaAereoObservaciones: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('ObservacionAereo'),
      Preferencias: null,
      InfoEspecifica: textoObservacion,
    }
    ListaPreferencias.push(preferenciaAereoObservaciones)

    return ListaPreferencias;


  }

  //Obter número de fila de asiento en aereo
  obtenerNumero(): string | null {
    let numeroFila: number | null = null;
    if (this.numero !== null && this.numero > 0) {
      numeroFila = this.numero;

    }

    return numeroFila?.toString();
  }

  //Actualziar preferencias aereo
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias
    let preferenciasTipoAereo = this.preferencias.filter(o => o.TipoProducto === ETipoProducto.Aereo);
    let idsPreferencias = preferenciasTipoAereo.map(o => o.Id);
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));
    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if(preferencia.Tipo == 6){
        if(preferencia.InfoEspecifica !== null){
          this.numero = parseInt(preferencia.InfoEspecifica);
        }
      }
      grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
    });

    let preferenciaPreferenciaCompaniasAreas: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('CompaniasAreas'));
    let preferenciaTextoObservacionAereo: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('ObservacionAereo'));

    this.Grupo_Preferencia_Aereo_Companias.actualizarSeleccion(preferenciaPreferenciaCompaniasAreas?.Preferencias);
    this.Grupo_Preferencia_Aereo_Observaciones.actualizar(preferenciaTextoObservacionAereo?.InfoEspecifica);
  }

  //Valdiar preferencias aereo
  validarPreferencias() {
    let validacionPreferenciasAereo = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    let estadoAereoCompanias = this.Grupo_Preferencia_Aereo_Companias.validarPreferencias();
    return validacionPreferenciasAereo && estadoAereoCompanias;
  }
}

